/** Per-tab assistance. The admin's HttpOnly login cookie is never replaced. */
export interface AssistanceSession {
  id: string;
  token: string;
  provider_id: string;
  provider_name: string;
  actor_name: string;
  actor_user_id: string;
  expires_at: string;
  reason: string;
}
const KEY = "gaamed.admin-assistance.v1";

export function getAssistance(): AssistanceSession | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as AssistanceSession;
    return typeof value.token === "string" && typeof value.id === "string" ? value : null;
  } catch { return null; }
}

export function saveAssistance(session: AssistanceSession) {
  sessionStorage.setItem(KEY, JSON.stringify(session));
}

export function clearAssistance() {
  sessionStorage.removeItem(KEY);
}
